// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1__d86d29881271517b884e","cls2":"PaperAbstract-cls2___77d4229041fe6a78079 PaperAbstract-cls1__d86d29881271517b884e"};